import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/overview/dashboard";

export const Route = createFileRoute("/admin/_overview/dashboard")({
  component: Page,
});
